import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
  SvgIcon,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import ExclamationTriangleIcon from '@heroicons/react/24/outline/ExclamationTriangleIcon';
import ChatBubbleLeftRightIcon from '@heroicons/react/24/outline/ChatBubbleLeftRightIcon';

const WHATSAPP_SOPORTE = '5491173622796';

export const MENSAJE_ALERTA_PAGO_DEFAULT =
  'Tu empresa tiene un pago de la suscripción pendiente. Para no interrumpir el servicio, ' +
  'regularizalo o escribinos y lo vemos juntos.';

export const AlertaPagoModal = ({ open, mensaje, onClose }) => {
  const theme = useTheme();
  const esMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const abrirSoporte = () => {
    window.open(`https://wa.me/${WHATSAPP_SOPORTE}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <Dialog
      open={open}
      // Deliberado: solo se cierra con el botón. Un click al costado o Escape
      // lo descartarían sin haberlo leído.
      onClose={(_event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        onClose();
      }}
      disableEscapeKeyDown
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: 'hidden',
          border: `1px solid ${theme.palette.warning.alpha12}`,
        },
      }}
    >
      {/* Banda de encabezado: da peso al aviso sin el rojo de un error. */}
      <Box
        sx={{
          px: 3,
          pt: 4,
          pb: 3,
          textAlign: 'center',
          backgroundColor: theme.palette.warning.lightest,
          borderBottom: `1px solid ${theme.palette.warning.alpha12}`,
        }}
      >
        <Box
          sx={{
            width: 56,
            height: 56,
            mx: 'auto',
            mb: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            backgroundColor: theme.palette.warning.alpha12,
            color: theme.palette.warning.dark,
          }}
        >
          <SvgIcon fontSize="medium">
            <ExclamationTriangleIcon />
          </SvgIcon>
        </Box>
        <Typography variant="h6" sx={{ color: theme.palette.warning.darkest }}>
          Tenés un pago atrasado
        </Typography>
      </Box>

      <DialogContent sx={{ px: 3, py: 3 }}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ textAlign: 'center', whiteSpace: 'pre-line' }}
        >
          {mensaje || MENSAJE_ALERTA_PAGO_DEFAULT}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, pt: 0 }}>
        <Stack
          direction={esMobile ? 'column-reverse' : 'row'}
          spacing={1.5}
          sx={{ width: '100%' }}
        >
          <Button fullWidth color="inherit" onClick={onClose}>
            Cerrar
          </Button>
          <Button
            fullWidth
            variant="contained"
            color="success"
            onClick={abrirSoporte}
            startIcon={
              <SvgIcon fontSize="small">
                <ChatBubbleLeftRightIcon />
              </SvgIcon>
            }
          >
            Contactar a soporte
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
